module.exports = __webpack_public_path__ + "img/3.718affdf.jpg";